"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3153],{

/***/ 1438:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ce": function() { return /* binding */ useIsDesktop; },
/* harmony export */   "Hi": function() { return /* binding */ Desktop; },
/* harmony export */   "Y9": function() { return /* binding */ LargeScreen; },
/* harmony export */   "_": function() { return /* binding */ MediumScreen; },
/* harmony export */   "ij": function() { return /* binding */ Mobile; }
/* harmony export */ });
/* unused harmony exports useCustomQuery, IEMediaQuery, EdgeMediaQuery */
/* harmony import */ var _material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(53450);
/* harmony import */ var _material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63457);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);



var useCustomQuery = function useCustomQuery(minWidth) {
  return _useMediaQuery("(min-width:".concat(minWidth, "px)"));
};
var useIsDesktop = function useIsDesktop() {
  return (0,_material_ui_core_useMediaQuery__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function (theme) {
    return theme.breakpoints.up("md");
  });
};
var Mobile = function Mobile(_ref) {
  var children = _ref.children,
      _ref$aboveTheFold = _ref.aboveTheFold,
      aboveTheFold = _ref$aboveTheFold === void 0 ? false : _ref$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    mdUp: true,
    children: children
  });
};
var Desktop = function Desktop(_ref2) {
  var children = _ref2.children,
      _ref2$aboveTheFold = _ref2.aboveTheFold,
      aboveTheFold = _ref2$aboveTheFold === void 0 ? false : _ref2$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    smDown: true,
    children: children
  });
};
var MediumScreen = function MediumScreen(_ref3) {
  var children = _ref3.children,
      _ref3$aboveTheFold = _ref3.aboveTheFold,
      aboveTheFold = _ref3$aboveTheFold === void 0 ? false : _ref3$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    only: ["xs", "sm", "xl"],
    children: children
  });
};
var LargeScreen = function LargeScreen(_ref4) {
  var children = _ref4.children,
      _ref4$aboveTheFold = _ref4.aboveTheFold,
      aboveTheFold = _ref4$aboveTheFold === void 0 ? false : _ref4$aboveTheFold;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_Hidden__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    implementation: aboveTheFold ? "css" : "js",
    lgDown: true,
    children: children
  });
};
var IEMediaQuery = "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)";
var EdgeMediaQuery = "@supports (-ms-ime-align:auto)";

/***/ }),

/***/ 152:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qo": function() { return /* binding */ FooterLinks; },
  "hA": function() { return /* binding */ FooterSocialLinks; },
  "oc": function() { return /* binding */ GeneralLinks; }
});

// UNUSED EXPORTS: ContactUsLinks, HeaderSocialLinks, McOrderLinks, MenuLinksBottom, MenuLinksTop, SocialLinks

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/Icons/AccessibilityIcon.tsx


var SvgComponent = function SvgComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "18",
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18.0607 6.27347V13.2245H1.93849V1.66642H18.0607V6.27347ZM19.6887 13.9961V1.12899C19.6887 0.536512 19.2031 0.0562744 18.603 0.0562744H1.39511C0.796091 0.0562744 0.310547 0.536512 0.310547 1.12899V13.9961C0.310547 14.5886 0.796091 15.0688 1.39511 15.0688H18.603C19.202 15.0688 19.6887 14.5886 19.6887 13.9961ZM9.71746 2.33233C9.0868 2.33233 8.57616 2.83847 8.57616 3.46116C8.57616 4.08493 9.0868 4.58999 9.71746 4.58999C10.3481 4.58999 10.8588 4.08493 10.8588 3.46116C10.8588 2.83739 10.3481 2.33233 9.71746 2.33233ZM9.65059 5.25479L9.79602 6.63503H11.7219C11.8987 6.63503 12.0416 6.77857 12.0416 6.95555V7.03757C12.0416 7.21456 11.8987 7.35809 11.7219 7.35809H9.87221L9.94737 8.07146H12.566C12.8683 8.07146 13.1214 8.23226 13.1858 8.44702C13.2076 8.48371 13.2251 8.52364 13.2414 8.56465L14.0194 10.6777L14.5497 10.5374C14.889 10.4478 15.2273 10.6054 15.3047 10.8903C15.3811 11.1741 15.1683 11.4785 14.829 11.5691L14.0281 11.8022C14 11.8254 13.969 11.8348 13.9352 11.845C13.9219 11.849 13.9081 11.8531 13.8939 11.8583L13.8791 11.8635C13.7919 11.8942 13.6828 11.9326 13.5982 11.9101C13.3626 11.9069 13.248 11.6867 13.1836 11.4515L12.2976 9.04165H9.40836C9.05703 9.04165 8.77116 8.82473 8.77116 8.5571C8.77116 8.53889 8.76441 8.52108 8.75783 8.50368C8.74919 8.48086 8.74081 8.45874 8.74824 8.43731L8.67732 5.21054C8.63367 4.66123 9.67241 4.56734 9.65168 5.25587L9.65059 5.25479ZM9.32508 12.3169C10.3136 12.3169 11.1025 11.9899 11.7517 11.3715H11.7495L11.8903 11.2474C12.0758 11.105 12.1085 10.8406 11.9645 10.6582L11.9197 10.601C11.7757 10.4186 11.4844 10.3431 11.2989 10.4866L11.1658 10.5902C10.7206 11.0337 10.0758 11.3122 9.36545 11.3122C8.02557 11.3122 6.93882 10.3215 6.93882 9.09984C6.93882 8.43506 7.2476 7.86525 7.75606 7.45948L7.82917 7.39257C8.02557 7.2663 8.08121 7.00622 7.95355 6.81197L7.91427 6.75153C7.78661 6.55728 7.51602 6.49792 7.31962 6.62419L7.1745 6.72671C6.3769 7.303 5.91972 8.15771 5.91972 9.16675C5.91972 10.9064 7.444 12.3169 9.32508 12.3169ZM11.9768 16.379H13.392C13.7411 16.379 14.0248 16.7286 14.0248 17.1614C14.0248 17.5941 13.7411 17.9438 13.392 17.9438H6.60634C6.25719 17.9438 5.9735 17.5941 5.9735 17.1614C5.9735 16.7286 6.25719 16.379 6.60634 16.379H8.02151V15.5966H11.9768V16.379ZM14.8454 3.31217L16.0499 3.7978L16.051 3.79564C16.1798 3.84636 16.1874 3.98558 16.0685 4.10213L15.5371 4.62661L16.4515 5.52989C16.5038 5.58169 16.5082 5.66047 16.4624 5.7058L16.1405 6.02416C16.0936 6.06949 16.015 6.06517 15.9627 6.01337L15.0494 5.11009L14.5191 5.63457C14.4013 5.75113 14.2616 5.74357 14.2092 5.61731L13.7182 4.42589C13.692 4.36274 13.6577 4.27936 13.6233 4.19598C13.5889 4.11263 13.5546 4.02927 13.5284 3.96615L13.0374 2.77473C12.985 2.64847 13.0472 2.58695 13.1749 2.63875L14.3805 3.12439C14.4444 3.15029 14.5287 3.18428 14.613 3.21828C14.6972 3.25227 14.7815 3.28626 14.8454 3.31217Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var AccessibilityIcon = (SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/CompaniesIcon.tsx


var CompaniesIcon_SvgComponent = function SvgComponent() {
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.0192 4.1665H2.98149C2.25658 4.1665 1.66699 4.75627 1.66699 5.481V14.3382C1.66699 15.0631 2.25658 15.6527 2.98149 15.6527H17.0192C17.7441 15.6527 18.3337 15.0631 18.3337 14.3382V5.481C18.3337 4.75626 17.7441 4.1665 17.0192 4.1665ZM17.71 5.481V8.20371C16.258 8.20371 10.2119 8.20406 10.1535 8.20515C10.11 8.20585 10.086 8.19186 10.0657 8.15313C9.92937 7.89051 9.83081 7.61452 9.77006 7.3252C9.74965 7.2275 9.7104 7.17357 9.612 7.17496C9.47049 7.17693 9.3247 7.18577 9.18793 7.2204C8.77696 7.32393 8.41878 7.53864 8.08137 7.78779C7.91997 7.90711 7.76914 8.04104 7.61237 8.16678C7.58914 8.18522 7.56069 8.19713 7.52271 8.21915V6.43914V4.7898H17.0192C17.4001 4.79003 17.7101 5.09988 17.7101 5.48083L17.71 5.481ZM2.98149 4.79019H6.34573V6.25743V8.11395C6.29243 8.09569 6.24364 8.0873 6.20381 8.06389C6.12375 8.01632 6.04825 7.9614 5.9724 7.90763C5.52913 7.59292 5.00226 7.46348 4.4823 7.33793C4.44322 7.32868 4.40258 7.32463 4.36258 7.32267C4.14395 7.31076 4.07255 7.34967 3.99798 7.55356C3.93618 7.72317 3.91329 7.97551 3.85895 8.14777C3.85184 8.16997 3.82501 8.20194 3.80692 8.20194C3.69946 8.20338 2.77233 8.2039 2.29048 8.20425V5.48095C2.29071 5.1 2.60056 4.79014 2.98151 4.79014L2.98149 4.79019ZM2.29068 14.3382V9.3749H4.69047C4.63862 9.43068 4.59815 9.47716 4.55445 9.52051C4.39588 9.67839 4.31824 9.75389 4.15754 9.90944C4.10176 9.96361 4.0984 10.0259 4.10835 10.0966C4.17991 10.5896 4.15627 11.1659 4.15147 11.6655C4.15043 11.7555 4.14384 11.8455 4.13904 11.9521C4.1646 11.9375 4.18471 11.9322 4.1957 11.9187C4.28946 11.8048 4.37183 11.68 4.47596 11.5766C4.832 11.2218 5.20019 10.8782 5.55518 10.5223C5.81076 10.266 6.05314 9.99648 6.3012 9.73275C6.31293 9.72032 6.32484 9.70772 6.34594 9.68517V15.0288H2.98155C2.6006 15.0291 2.29074 14.719 2.29074 14.3381L2.29068 14.3382ZM17.0192 15.0291H7.52298V9.49493C7.76931 9.78172 8.00192 10.0661 8.24929 10.337C8.48139 10.5913 8.7355 10.8257 8.96922 11.0788C9.20595 11.3356 9.57234 11.7613 9.80178 12.0249C9.81473 12.0398 9.82751 12.0543 9.85028 12.0805C9.85612 12.0478 9.86184 12.0279 9.86323 12.0074C9.90832 11.4232 9.9522 10.8389 9.99925 10.2551C10.0041 10.1945 9.99266 10.1448 9.95075 10.1042C9.77404 9.93283 9.45423 9.60535 9.27665 9.4347C9.25873 9.41765 9.23936 9.40221 9.20953 9.3766H17.71V14.3381C17.7099 14.7191 17.4 15.0292 17.0191 15.0292L17.0192 15.0291Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var CompaniesIcon = (CompaniesIcon_SvgComponent);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./theme/colors.ts
var colors = __webpack_require__(75741);
;// CONCATENATED MODULE: ./components/Icons/ContactUsIcon.tsx


var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var ContactUsIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.cherryRed */.Z.cherryRed : _ref$color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var w = 30;
  var h = 30;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("svg", _objectSpread(_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("g", {
      clipPath: "url(#a)",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.75 8.125H8.25A1.125 1.125 0 0 0 7.125 9.25v9a1.125 1.125 0 0 0 1.125 1.125h2.813a2.25 2.25 0 0 1 1.8.9L15 23.125l2.137-2.85a2.251 2.251 0 0 1 1.8-.9h2.813a1.125 1.125 0 0 0 1.125-1.125v-9a1.125 1.125 0 0 0-1.125-1.125ZM8.25 7A2.25 2.25 0 0 0 6 9.25v9a2.25 2.25 0 0 0 2.25 2.25h2.813a1.125 1.125 0 0 1 .9.45L14.1 23.8a1.126 1.126 0 0 0 1.8 0l2.138-2.85a1.125 1.125 0 0 1 .9-.45h2.812A2.25 2.25 0 0 0 24 18.25v-9A2.25 2.25 0 0 0 21.75 7H8.25Z",
        fill: color
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)("clipPath", {
        id: "a",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
          fill: "#fff",
          transform: "translate(6 7)",
          d: "M0 0h18v18H0z"
        })
      })
    })]
  }));
};

/* harmony default export */ var ContactUsIcon = (ContactUsIcon_SvgComponent);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 2 modules
var styled_components_browser_esm = __webpack_require__(50066);
;// CONCATENATED MODULE: ./components/Icons/FacebookIcon.tsx





var StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "FacebookIcon__StyledSVG",
  componentId: "sc-1vbpkri-0"
})(["", "{width:23px;height:23px}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var FacebookIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.black */.Z.black : _ref$color;
  var w = 22;
  var h = 22;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: w,
    height: h,
    viewBox: "0 0 22.874 22.884",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-name": "FB icon",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 567",
        d: "M10.322.009c-.241.019-.995.131-1.415.21a11.251 11.251 0 0 0-4.438 2.018 11.411 11.411 0 0 0-2.612 2.779 11.164 11.164 0 0 0 1.374 14.019 11.069 11.069 0 0 0 5.676 3.111A12.163 12.163 0 0 0 14.078 22a11.246 11.246 0 0 0 2.681-1.107A11.538 11.538 0 0 0 19.8 18.31a11.229 11.229 0 0 0-.072-14.353 14.556 14.556 0 0 0-1.292-1.293A11.18 11.18 0 0 0 12 .036a17.324 17.324 0 0 0-1.678-.027m2.1 1.521a8.981 8.981 0 0 1 3.03.937A9.422 9.422 0 0 1 19.91 6.92a9.794 9.794 0 0 1 .9 5.639 8.611 8.611 0 0 1-.957 2.969 8.536 8.536 0 0 1-1.767 2.492 8.781 8.781 0 0 1-1.56 1.289 10.488 10.488 0 0 1-3.366 1.43 9.74 9.74 0 0 1-2.013.105 8.4 8.4 0 0 1-1.917-.107 11.315 11.315 0 0 1-3.708-1.624 13.191 13.191 0 0 1-2.333-2.378 10.7 10.7 0 0 1-1.03-1.913 9.321 9.321 0 0 1-.662-3.738 7.927 7.927 0 0 1 .217-2.146 9.977 9.977 0 0 1 2.572-4.615 9.626 9.626 0 0 1 5.671-2.79 6.856 6.856 0 0 1 1.343-.058 8.169 8.169 0 0 1 1.123.055",
        transform: "translate(.251 .26)",
        stroke: color,
        strokeWidth: "0.5px",
        fill: "#161615"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 568",
        d: "M329.33 155.9a2.319 2.319 0 0 0-1.443.731 2.538 2.538 0 0 0-.669 1.922c-.02.308-.062 1.4-.062 1.626v.1h-1.327v2.105h1.341l.013 2.276c.007 1.251.019 2.816.027 3.475l.013 1.2.89.013 1.288.019.4.005.005-3.493.005-3.493h1.02c.953 0 1.02 0 1.031-.037a14.268 14.268 0 0 0 .166-1.765l.014-.3h-2.232v-.625a3.745 3.745 0 0 1 .082-1.094.581.581 0 0 1 .492-.442 6.252 6.252 0 0 1 1.325 0c.151.018.275.031.277.029s.209-1.352.232-1.542c.012-.1.023-.24.026-.32l.005-.144-.071-.035a5.185 5.185 0 0 0-1.255-.183c-.392-.029-1.369-.042-1.592-.021",
        transform: "translate(-317.748 -151.233)",
        fill: "#161615"
      })]
    })
  });
};

/* harmony default export */ var FacebookIcon = (FacebookIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/InstagramIcon.tsx





var InstagramIcon_StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "InstagramIcon__StyledSVG",
  componentId: "sc-1f4l3nb-0"
})(["", "{width:20px;height:20px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var InstagramIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.black */.Z.black : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 22 : _ref$height;
  var w = width;
  var h = height;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(InstagramIcon_StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: w,
    height: h,
    viewBox: "0 0 20.59 20.59",
    className: "instagram-icon",
    "aria-labelledby": "mcd-instagram-title mcd-instagram-desc",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      id: "mcd-instagram-title",
      children: "\u05DC\u05D9\u05E0\u05E7 \u05E9\u05DE\u05E2\u05D1\u05D9\u05E8 \u05D0\u05EA \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9 \u05DC\u05D0\u05D9\u05E0\u05E1\u05D8\u05D0\u05D2\u05E8\u05D0\u05DD \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3\u05E1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("desc", {
      id: "mcd-instagram-desc",
      children: "\u05D0\u05D9\u05D9\u05E7\u05D5\u05DF \u05E9\u05DC \u05D0\u05D9\u05E0\u05E1\u05D8\u05D0\u05D2\u05E8\u05D0\u05DD \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3\u05E1"
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-name": "Insta icon",
      transform: "translate(.5 .5)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 289",
        d: "M16.4 2H7.186A5.187 5.187 0 0 0 2 7.186V16.4a5.187 5.187 0 0 0 5.186 5.19H16.4a5.187 5.187 0 0 0 5.19-5.19V7.186A5.187 5.187 0 0 0 16.4 2zm4.033 14.4a4.035 4.035 0 0 1-4.033 4.038H7.186A4.035 4.035 0 0 1 3.152 16.4V7.186a4.035 4.035 0 0 1 4.034-4.034H16.4a4.035 4.035 0 0 1 4.033 4.033z",
        transform: "translate(-2 -2)",
        stroke: color,
        fill: "evenodd"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 290",
        d: "M13.284 8.588a4.7 4.7 0 1 0 4.7 4.7 4.7 4.7 0 0 0-4.7-4.7zm0 8.348a3.653 3.653 0 1 1 3.653-3.653 3.653 3.653 0 0 1-3.653 3.653z",
        transform: "translate(-3.489 -3.489)",
        stroke: color,
        fill: "evenodd"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("circle", {
        "data-name": "Ellipse 5",
        cx: "1",
        cy: "1",
        r: "1",
        transform: "translate(14 3.795)"
      })]
    })]
  });
};

/* harmony default export */ var InstagramIcon = (InstagramIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/MailIcon.tsx


var MailIcon_excluded = ["color"];

function MailIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function MailIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? MailIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : MailIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var MailIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.cherryRed */.Z.cherryRed : _ref$color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, MailIcon_excluded);

  var w = 30;
  var h = 30;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", MailIcon_objectSpread(MailIcon_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M22.2 9c.994 0 1.8.776 1.8 1.733v9.534c0 .957-.806 1.733-1.8 1.733H7.8c-.994 0-1.8-.776-1.8-1.733v-9.534C6 9.776 6.806 9 7.8 9h14.4Zm.777 1.296L15 17.124l-7.977-6.828a.838.838 0 0 0-.123.437v9.534c0 .085.013.168.037.246l1.448-1.448 1.448-1.447.648.649-1.425 1.425-1.425 1.426c.055.01.111.015.169.015h14.34L20.706 19.7l-1.433-1.433.649-.65 1.534 1.534 1.533 1.532a.838.838 0 0 0 .111-.416v-9.534a.839.839 0 0 0-.123-.437Zm-.854-.43H7.876L15 15.964l7.123-6.098Z",
      fill: color
    })
  }));
};

/* harmony default export */ var MailIcon = (MailIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/PhoneIcon.tsx


var PhoneIcon_excluded = ["color"];

function PhoneIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function PhoneIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? PhoneIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : PhoneIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var PhoneIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.cherryRed */.Z.cherryRed : _ref$color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, PhoneIcon_excluded);

  var w = 30;
  var h = 30;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", PhoneIcon_objectSpread(PhoneIcon_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M9.56 6.903c1.317 0 2.788 1.339 3.226 2.7.483 1.333.161 2.686-.886 3.77-.204.197.458 1.519 1.61 2.779 1.193 1.305 2.385 1.994 2.641 1.73.83-.944 2.06-1.338 3.24-1.012 1.48.361 2.936 1.894 3.014 3.43 0 .882-.433 1.586-1.32 2.509l-.51.52c-.989.95-2.695.807-4.537.092-4.149-1.63-7.877-5.588-9.493-10-.698-1.927-.817-3.687.187-4.725.078-.073.16-.154.264-.26.05-.05.24-.248.284-.294.836-.857 1.428-1.24 2.28-1.24Zm0 .902c-.554 0-.982.277-1.666.978l-.285.295a7.71 7.71 0 0 1-.277.273c-.654.676-.555 2.14.028 3.75 1.53 4.174 5.076 7.94 8.985 9.475 1.547.6 2.982.722 3.625.104.067-.07.403-.41.497-.508.735-.764 1.066-1.303 1.067-1.848-.055-1.079-1.215-2.3-2.354-2.578-.875-.242-1.77.045-2.398.758-.819.848-2.362-.044-3.906-1.732-1.514-1.656-2.343-3.313-1.582-4.048.801-.83 1.035-1.812.67-2.82-.334-1.036-1.5-2.099-2.405-2.099ZM15.59 6c4.02 0 7.28 3.287 7.406 7.423l.004.25h-.872c0-3.675-2.796-6.642-6.308-6.766l-.23-.004V6Zm0 3.61c2.109 0 3.817 1.696 3.918 3.858l.005.204h-.872c0-1.698-1.265-3.062-2.877-3.154l-.174-.005V9.61Z",
      fill: color
    })
  }));
};

/* harmony default export */ var PhoneIcon = (PhoneIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/RedesignIcons/socialIcons/Twitter.tsx


var TwitterIcon = function TwitterIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width || "25",
    height: height || "24",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M20.7654 2.21671C21.0997 2.5263 21.1244 3.05334 20.8204 3.39389L14.5029 10.4721L20.9053 20.7193C21.0656 20.9759 21.0759 21.3011 20.9322 21.5677C20.7885 21.8343 20.5136 22 20.215 22H15.3059C15.0262 22 14.7658 21.8544 14.6157 21.6141L10.4741 14.9854L4.4568 21.7272C4.15285 22.0678 3.63539 22.0929 3.30103 21.7833C2.96667 21.4737 2.94202 20.9467 3.24598 20.6061L9.56351 13.5279L3.16112 3.28073C3.0008 3.02413 2.99047 2.69895 3.13417 2.43233C3.27787 2.16571 3.55277 2.00001 3.85139 2.00001H8.76048C9.04022 2.00001 9.30056 2.14557 9.45075 2.38594L13.5923 9.0146L19.6096 2.27279C19.9136 1.93223 20.431 1.90713 20.7654 2.21671ZM5.34185 3.66667L15.7551 20.3333H18.7246L8.31134 3.66667H5.34185Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var Twitter = (TwitterIcon);
;// CONCATENATED MODULE: ./components/Icons/RedesignIcons/socialIcons/WhatsAppIcon.tsx


var WhatsAppIcon = function WhatsAppIcon(_ref) {
  var width = _ref.width,
      height = _ref.height;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", {
    width: width || "24",
    height: height || "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      d: "M17.7325 13.6192L14.6553 12.0808C14.5342 12.0204 14.3993 11.9931 14.2642 12.0015C14.1291 12.01 13.9987 12.0539 13.886 12.1288L12.4734 13.0712C11.8249 12.7147 11.2913 12.1811 10.9348 11.5327L11.8772 10.1202C11.9521 10.0075 11.9961 9.87709 12.0045 9.74203C12.0129 9.60697 11.9856 9.47208 11.9253 9.35096L10.3866 6.27404C10.3229 6.14526 10.2243 6.03692 10.1021 5.96129C9.97989 5.88567 9.83894 5.84578 9.69523 5.84615C8.67507 5.84615 7.69669 6.25137 6.97533 6.97267C6.25396 7.69396 5.84871 8.67224 5.84871 9.69231C5.85125 11.9357 6.74363 14.0864 8.33008 15.6727C9.91653 17.259 12.0675 18.1513 14.3111 18.1538C14.8162 18.1538 15.3164 18.0544 15.7831 17.8611C16.2497 17.6678 16.6738 17.3845 17.031 17.0273C17.3881 16.6702 17.6715 16.2462 17.8648 15.7796C18.0581 15.3129 18.1576 14.8128 18.1576 14.3077C18.1577 14.1648 18.118 14.0247 18.0429 13.9031C17.9678 13.7815 17.8604 13.6832 17.7325 13.6192ZM14.3111 16.6154C12.4754 16.6133 10.7155 15.8833 9.41748 14.5854C8.11947 13.2875 7.38935 11.5278 7.38732 9.69231C7.38717 9.15877 7.57191 8.64166 7.91012 8.22898C8.24832 7.8163 8.71909 7.53355 9.2423 7.42885L10.3463 9.64038L9.40674 11.0385C9.33653 11.1438 9.29339 11.2648 9.28115 11.3907C9.2689 11.5167 9.28793 11.6437 9.33654 11.7606C9.88696 13.0686 10.9277 14.1092 12.2359 14.6596C12.3531 14.7104 12.4811 14.7312 12.6083 14.7201C12.7356 14.709 12.8581 14.6664 12.9648 14.5962L14.3697 13.6596L16.5815 14.7635C16.4759 15.2872 16.1919 15.7582 15.7779 16.0959C15.3638 16.4336 14.8454 16.6172 14.3111 16.6154ZM12.0031 2C10.2765 1.99962 8.57918 2.44624 7.07637 3.29637C5.57357 4.14651 4.31649 5.3712 3.42749 6.85125C2.53848 8.3313 2.04784 10.0163 2.00333 11.7422C1.95881 13.4681 2.36193 15.1761 3.17345 16.7L2.082 19.974C1.99159 20.2451 1.97847 20.536 2.04411 20.8141C2.10975 21.0922 2.25155 21.3465 2.45362 21.5486C2.6557 21.7507 2.91005 21.8924 3.18819 21.9581C3.46632 22.0237 3.75724 22.0106 4.02834 21.9202L7.30269 20.8288C8.64394 21.5422 10.1301 21.9406 11.6483 21.9938C13.1666 22.0471 14.677 21.7538 16.0649 21.1363C17.4529 20.5187 18.6819 19.5931 19.6587 18.4297C20.6355 17.2663 21.3343 15.8957 21.7023 14.4219C22.0702 12.9481 22.0975 11.4098 21.7821 9.92388C21.4667 8.43795 20.8169 7.0434 19.882 5.84607C18.9471 4.64875 17.7517 3.68012 16.3865 3.01371C15.0214 2.3473 13.5223 2.00062 12.0031 2ZM12.0031 20.4615C10.5155 20.4626 9.05392 20.0708 7.7662 19.326C7.67192 19.2713 7.56709 19.2373 7.45867 19.2262C7.35025 19.2151 7.2407 19.2271 7.13729 19.2615L3.54079 20.4615L4.73995 16.8654C4.77451 16.7621 4.78673 16.6526 4.77579 16.5441C4.76485 16.4357 4.731 16.3309 4.67648 16.2365C3.74367 14.624 3.36915 12.7486 3.61102 10.9015C3.85289 9.05437 4.69763 7.33867 6.01419 6.02057C7.33075 4.70247 9.04555 3.85564 10.8926 3.61146C12.7396 3.36728 14.6155 3.7394 16.2294 4.67008C17.8434 5.60076 19.105 7.03799 19.8187 8.7588C20.5323 10.4796 20.6581 12.3878 20.1765 14.1874C19.6948 15.987 18.6327 17.5773 17.1549 18.7117C15.6771 19.8462 13.8662 20.4612 12.0031 20.4615Z",
      fill: "black"
    })
  });
};

/* harmony default export */ var socialIcons_WhatsAppIcon = (WhatsAppIcon);
;// CONCATENATED MODULE: ./components/Icons/TikTokIcon.tsx



var TikTokIcon_StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "TikTokIcon__StyledSVG",
  componentId: "sc-11jlfxl-0"
})(["", "{width:16px;height:19px;}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var TikTokIcon_SvgComponent = function SvgComponent() {
  var w = 22;
  var h = 22;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(TikTokIcon_StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "tiktok icon",
    width: w,
    height: h,
    viewBox: "0 0 16 18.658",
    "aria-labelledby": "mcd-tiktok-title mcd-tiktok-desc",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
      id: "mcd-tiktok-title",
      children: "\u05DC\u05D9\u05E0\u05E7 \u05E9\u05DE\u05E2\u05D1\u05D9\u05E8 \u05D0\u05EA \u05D4\u05DE\u05E9\u05EA\u05DE\u05E9 \u05DC\u05D8\u05D9\u05E7\u05D8\u05D5\u05E7 \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3\u05E1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("desc", {
      id: "mcd-tiktok-desc",
      children: "\u05D0\u05D9\u05D9\u05E7\u05D5\u05DF \u05E9\u05DC \u05D8\u05D9\u05E7\u05D8\u05D5\u05E7 \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3\u05E1"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      "data-name": "tiktok icon",
      d: "M12.237 0c.308 2.648 1.786 4.226 4.355 4.394v2.978a6.806 6.806 0 0 1-4.31-1.259v5.57c0 7.075-7.713 9.286-10.814 4.215-1.993-3.263-.772-8.99 5.62-9.219v3.14a9.249 9.249 0 0 0-1.483.364 2.531 2.531 0 0 0-2 2.972c.431 3.045 6.017 3.946 5.553-2V.006h3.084z",
      transform: "translate(-.591)",
      fill: "evenodd"
    })]
  });
};

/* harmony default export */ var TikTokIcon = (TikTokIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/WhatsappIcon.tsx


var WhatsappIcon_excluded = ["color"];

function WhatsappIcon_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function WhatsappIcon_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? WhatsappIcon_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : WhatsappIcon_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var WhatsappIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.cherryRed */.Z.cherryRed : _ref$color,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, WhatsappIcon_excluded);

  var w = 30;
  var h = 30;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("svg", WhatsappIcon_objectSpread(WhatsappIcon_objectSpread({
    viewBox: "0 0 ".concat(w, " ").concat(h),
    width: w,
    height: h,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "m10.918 22.396-.376-.207-3.96 1.259 1.287-3.796-.243-.399a8.64 8.64 0 0 1-1.262-4.51C6.364 9.922 10.304 6 15.182 6 20.06 6 24 9.921 24 14.743c0 4.82-3.94 8.742-8.818 8.742a8.824 8.824 0 0 1-4.264-1.089Zm-4.146-2.623L5 25l5.436-1.728a9.825 9.825 0 0 0 4.746 1.213c5.423 0 9.818-4.363 9.818-9.742C25 9.362 20.605 5 15.182 5s-9.818 4.362-9.818 9.743a9.64 9.64 0 0 0 1.408 5.03Zm7.973-7.477c.119.237.29.718.016 1.263a2.727 2.727 0 0 1-.386.601c.175.244.42.546.712.806a4.3 4.3 0 0 0 1.066.706l.274-.347c.18-.27.484-.545.938-.596.324-.037.608.068.696.1l.013.005c.158.057.528.233.81.368.316.151.633.307.743.36l.002.002.1.048.033.016c.044.021.103.05.162.082.088.048.346.188.52.475v.001c.145.238.164.488.17.562v.002c.01.127.007.26-.004.39a3.636 3.636 0 0 1-.204.903c-.205.569-.706.961-1.036 1.174-.723.438-1.309.548-2.04.548-.511 0-1.119-.233-2.202-.655-1.273-.498-2.272-1.375-2.947-2.102a11.35 11.35 0 0 1-1.107-1.403 6.087 6.087 0 0 1-.564-.898c-.236-.46-.502-1.134-.502-1.878 0-1.369.717-2.125.965-2.388.242-.256.532-.43.869-.533.29-.087.582-.12.884-.132.05-.002.389-.014.724.186.343.204.541.527.669.833l.626 1.501Zm4.438 4.162.117.057c.147.07.247.118.29.189.052.087.052.508-.125.999-.176.491-1.43 1-1.43 1s-.388.316-2.543-.526c-1.992-.779-3.304-2.711-3.574-3.11l-.046-.065c-.105-.14-.864-1.14-.864-2.174 0-.967.48-1.476.7-1.709l.041-.044c.194-.21.619-.263.619-.263s.228-.037.352-.037h.013c.123 0 .294 0 .463.405.059.138.143.343.233.559.183.442.386.932.42 1.002.054.105.09.227.019.368l-.03.06a1.197 1.197 0 0 1-.182.291 8.464 8.464 0 0 0-.11.13c-.072.088-.145.175-.208.238-.105.105-.216.22-.093.43.124.21.55.897 1.18 1.455.678.6 1.268.854 1.566.982.057.024.103.044.138.061.212.105.335.088.458-.052.124-.14.53-.614.672-.825.14-.21.282-.175.476-.105.194.07 1.237.58 1.448.684Z",
      fill: color
    })
  }));
};

/* harmony default export */ var WhatsappIcon = (WhatsappIcon_SvgComponent);
;// CONCATENATED MODULE: ./components/Icons/YoutubeIcon.tsx





var YoutubeIcon_StyledSVG = styled_components_browser_esm/* default.svg.withConfig */.ZP.svg.withConfig({
  displayName: "YoutubeIcon__StyledSVG",
  componentId: "sc-1axl2ze-0"
})(["", "{width:29px;height:22px}"], function (p) {
  return p.theme.breakpoints.down("sm");
});

var YoutubeIcon_SvgComponent = function SvgComponent(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? colors/* default.black */.Z.black : _ref$color;
  var w = 22;
  var h = 22;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(YoutubeIcon_StyledSVG, {
    xmlns: "http://www.w3.org/2000/svg",
    width: w,
    height: h,
    viewBox: "0 0 38 33",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("g", {
      "data-name": "YouTube icon",
      transform: "translate(1.5 1.5)",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("path", {
        "data-name": "Path 296",
        d: "m52 44.99-4.5 2.5-4.5 2.5v-10l4.5 2.5z",
        transform: "translate(-29.499 -29.99)",
        fill: "none",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "2px"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("rect", {
        "data-name": "Rectangle 1402",
        width: "35",
        height: "30",
        rx: "5",
        fill: "none",
        stroke: color,
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: "3px"
      })]
    })
  });
};

/* harmony default export */ var YoutubeIcon = (YoutubeIcon_SvgComponent);
;// CONCATENATED MODULE: ./common/SiteLinks.tsx













var Links = {
  "יצירת קשר בווטסאפ": {
    title: "יצירת קשר בווטסאפ",
    link: "https://api.whatsapp.com/send?phone=972545738031",
    blank: true
  },
  "הזמנת כרטיסים לארגונים": {
    title: "הזמנת כרטיסים לארגונים",
    link: "https://api.whatsapp.com/send?phone=972545738031",
    blank: true
  },
  "מקדונלד׳ס ישראל": {
    title: "מקדונלד'ס ישראל",
    link: "https://www.mcdonalds.co.il/",
    blank: true
  },
  "בירור יתרה": {
    title: "בירור יתרה",
    link: "/balance",
    blank: false
  },
  "שאלות תשובות": {
    title: "שאלות תשובות",
    link: "/faq",
    blank: false
  },
  "הצהרת נגישות": {
    title: "הצהרת נגישות",
    link: "/accessibility",
    blank: false
  },
  "מדיניות הפרטיות אונליין": {
    title: "מדיניות הפרטיות אונליין",
    link: "https://www.mcdonalds.co.il/שונות/מדיניות_פרטיות",
    blank: false
  },
  "תנאי שימוש": {
    title: "תנאי שימוש",
    link: "/terms",
    blank: false
  },
  "מפת אתר": {
    title: "מפת אתר",
    link: "/sitemap",
    blank: false
  },
  "הנחיות לכתיבה נאותה": {
    title: "הנחיות לכתיבה נאותה",
    link: "/ethics",
    blank: false
  },
  "הזמנת גיפטקארד חברה": {
    title: "הזמנת גיפטקארד חברה",
    link: "/companies",
    blank: false
  },
  Facebook: {
    title: "Facebook",
    hebrewTitle: "פייסבוק",
    link: "https://www.facebook.com/mcdonaldsil",
    iconName: "facebook",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(FacebookIcon, {}),
    blank: true
  },
  Instagram: {
    title: "Instagram",
    hebrewTitle: "אינסטגרם",
    link: "https://www.instagram.com/mcdonalds_israel/",
    iconName: "instagram",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(InstagramIcon, {}),
    blank: true
  },
  Tiktok: {
    title: "Tiktok",
    hebrewTitle: "טיק טוק",
    link: "https://www.tiktok.com/@mcdonalds_il",
    iconName: "tiktok",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(TikTokIcon, {}),
    blank: true
  },
  Youtube: {
    title: "Youtube",
    hebrewTitle: "יוטיוב",
    link: "https://www.youtube.com/c/McDonaldsIsrael",
    iconName: "youtube",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(YoutubeIcon, {}),
    blank: true
  },
  WhatsappIcon: {
    title: "ווטסאפ",
    hebrewTitle: "ווטסאפ",
    link: "https://www.whatsapp.com/channel/0029VaG4JAu6RGJ9ptfG6c16",
    iconName: "whatsapp",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(socialIcons_WhatsAppIcon, {}),
    blank: true
  },
  Twitter: {
    title: "X",
    hebrewTitle: "טוויטר",
    link: "https://twitter.com/McDonaldsIL",
    iconName: "X",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(Twitter, {}),
    blank: true
  },
  ContactUs: {
    title: "צרו קשר",
    link: "/",
    iconName: "ContactUsIcon",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(ContactUsIcon, {})
  },
  Phone: {
    title: "03-7622035",
    link: "/tel:03-7622035",
    iconName: "phone",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(PhoneIcon, {})
  },
  Mail: {
    title: "info@lehamim.co.il",
    link: "/",
    iconName: "mail",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(MailIcon, {})
  },
  Whatsapp: {
    title: "ווטסאפ",
    link: "https://www.whatsapp.com/channel/0029VaG4JAu6RGJ9ptfG6c16",
    iconName: "whatsapp",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(WhatsappIcon, {})
  },
  McOrder: {
    title: "mcdonald order",
    link: "https://order.mcdonalds.co.il/?sw=1&utm_source=gift_card&utm_medium=link&utm_campaign=gift_card&shortlink=unbnu6mo&c=Giftcard&pid=GiftCard_site",
    blank: true
  },
  McOrderAndroid: {
    title: "mcdonald order android",
    link: "https://play.google.com/store/apps/details?id=il.co.inmanage.mcdonalds&hl=iw&gl=US",
    blank: true
  },
  McOrderIphone: {
    title: "mcdonald order iphone",
    link: "https://apps.apple.com/il/app/%D7%9E%D7%A7%D7%93%D7%95%D7%A0%D7%9C%D7%93%D7%A1-mcdonalds-israel/id967762450",
    blank: true
  },
  AccessibilityIcon: {
    title: "accessibility",
    link: "/accessibility",
    blank: false,
    iconName: "accessibility",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(AccessibilityIcon, {})
  },
  CompaniesIcon: {
    title: "companies",
    link: "/companies",
    blank: false,
    iconName: "companies",
    iconComp: /*#__PURE__*/(0,jsx_runtime.jsx)(CompaniesIcon, {})
  }
};
var MenuLinksTop = [Links["מגשי אירוח"], Links["חנויות המאפיה"], Links["מי אנחנו"], Links["צרו קשר"]];
var MenuLinksBottom = [Links["תעודת כשרות"], Links["תקנון"]]; // const obj = { hi:"1" };
// const objClone = { ...obj,showInLogIn:true; };

var FooterLinks = [Links["יצירת קשר בווטסאפ"], Links["הזמנת גיפטקארד חברה"], Links["מקדונלד׳ס ישראל"], Links["בירור יתרה"], Links["שאלות תשובות"], Links["הצהרת נגישות"], Links["מדיניות הפרטיות אונליין"], Links["תנאי שימוש"], Links["מפת אתר"]];
var GeneralLinks = [Links["יצירת קשר בווטסאפ"], Links["הזמנת גיפטקארד חברה"], Links["מקדונלד׳ס ישראל"], Links["בירור יתרה"], Links["שאלות תשובות"], Links["הצהרת נגישות"], Links["תנאי שימוש"], Links["הנחיות לכתיבה נאותה"], Links["מפת אתר"]];
var SocialLinks = {
  title: "עקבו אחרינו",
  links: [Links["FaceBook"], Links["Instagram"]]
};
var ContactUsLinks = {
  title: "דברו איתנו",
  links: [Links["Whatsapp"], Links["Phone"], Links["ContactUs"]]
};
var HeaderSocialLinks = {
  title: "עקבו אחרינו",
  links: [Links["CompaniesIcon"], Links["AccessibilityIcon"]]
};
var FooterSocialLinks = {
  title: "עקבו אחרינו",
  links: [Links["WhatsappIcon"], Links["Instagram"], Links["Tiktok"], Links["Facebook"], Links["Twitter"], Links["Youtube"]]
};
var McOrderLinks = {
  title: "mcdonald order",
  links: [Links["McOrderAndroid"], Links["McOrderIphone"], Links["McOrder"]]
};


/***/ }),

/***/ 16110:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4730);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);


var _excluded = ["href", "passHref", "children", "openInNewTab", "noScrollToTop", "ariaLabel"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var NextLink = function NextLink(_ref) {
  var href = _ref.href,
      passHref = _ref.passHref,
      children = _ref.children,
      _ref$openInNewTab = _ref.openInNewTab,
      openInNewTab = _ref$openInNewTab === void 0 ? false : _ref$openInNewTab,
      _ref$noScrollToTop = _ref.noScrollToTop,
      noScrollToTop = _ref$noScrollToTop === void 0 ? false : _ref$noScrollToTop,
      ariaLabel = _ref.ariaLabel,
      props = (0,_app_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, _excluded);

  // const { asPath } = useRouter()
  // const idx = asPath.indexOf("?")
  // const search = idx >= 0 ? asPath.slice(idx) : undefined
  // const link: UrlObject = {
  //   pathname: href,
  //   // search
  //  }
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
    href: href,
    passHref: true,
    scroll: !noScrollToTop,
    children: openInNewTab ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({
      target: "_blank",
      rel: "noreferrer"
    }, props), {}, {
      "aria-label": ariaLabel,
      children: children
    })) : passHref ? children : /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("a", _objectSpread(_objectSpread({}, props), {}, {
      "aria-label": ariaLabel,
      children: children
    }))
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_2__.memo)(NextLink));

/***/ }),

/***/ 85712:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17812);
/* harmony import */ var _material_ui_core_Box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50253);
/* harmony import */ var components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16110);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50066);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);





var StyledFooterSocialLink = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_Box__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
  displayName: "FooterSocialLinksList__StyledFooterSocialLink",
  componentId: "sc-17ruirk-0"
})(["display:flex;flex-direction:row;align-items:center;justify-content:\"center\";", " gap:16px;", "{margin:0px;justify-content:space-evenly;width:100%;}a{display:flex;", "{margin-right:0px;}}"], function (p) {
  return !(p !== null && p !== void 0 && p.$rightMargin) && "margin-right: auto;";
}, function (p) {
  return p.theme.breakpoints.down("sm");
}, function (p) {
  return p.theme.breakpoints.down("sm");
});
var StyledIconButton = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_material_ui_core_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).withConfig({
  displayName: "FooterSocialLinksList__StyledIconButton",
  componentId: "sc-17ruirk-1"
})(["padding:0;svg{width:22px;height:22px;}"]);

var FooterSocialLinksList = function FooterSocialLinksList(_ref) {
  var linkList = _ref.linkList,
      rightMargin = _ref.rightMargin;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledFooterSocialLink, {
    $rightMargin: rightMargin,
    children: linkList.map(function (item, index) {
      return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_Reusable_Bit_NextLink__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
        href: item.link,
        passHref: true,
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(StyledIconButton, {
          href: "",
          target: "_blank",
          "aria-label": "\u05D4".concat(item.hebrewTitle, " \u05E9\u05DC \u05DE\u05E7\u05D3\u05D5\u05E0\u05DC\u05D3'\u05E1"),
          children: item === null || item === void 0 ? void 0 : item.iconComp
        })
      }, index);
    })
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (FooterSocialLinksList);

/***/ })

}]);